module.exports = __webpack_public_path__ + "static/img/216.7fe6157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/216.jpg
// module id = 8P7L
// module chunks = 0